import React from 'react';

import useBlueConicPersonalizedReadingHub from '@hooks/useBlueConicPersonalizedReadingHub';
import type { FeedUnit } from '@interfaces/homepage';
import type { User } from '@utils/backend-api/currentUser';

import CommunityInsights from './CommunityInsights';
import DataTools from './DataTools';
import DeepResearch from './DeepResearch';
import MyTIHeader from './Header';
import Nav from './Nav';
import Newsletters from './Newsletters';
import OrgCharts from './OrgCharts';
import ReadingStats from './ReadingStats';
import RecommendedArticles from './RecommendedArticles';
import Reporters from './Reporters';
import Topics from './Topics';
import { MY_TI_COMPONENT_LIST, UserAccess } from './constants';

const COMPONENT_MAP: Record<string, React.ComponentType> = {
  CommunityInsights,
  DataTools,
  DeepResearch,
  Nav,
  Newsletters,
  OrgCharts,
  ReadingStats,
  RecommendedArticles,
  Reporters,
  Topics,
};

interface MyTIContentProps {
  forumPosts: FeedUnit;
  initialCurrentUser?: User;
}

const MyTIContent = ({ forumPosts, initialCurrentUser }: MyTIContentProps) => {
  const readingStats = useBlueConicPersonalizedReadingHub();

  const userAccess = initialCurrentUser?.is_pro_subscriber ? UserAccess.Pro : UserAccess.Annual;
  const components = MY_TI_COMPONENT_LIST[userAccess];
  const additionalProps = {
    forumPosts,
    initialCurrentUser,
  };

  return (
    <main className="my-ti-container relative w-full px-16 sm:px-28">
      <div className="mx-auto flex w-full max-w-container-lg flex-col">
        <MyTIHeader initialCurrentUser={initialCurrentUser} />
        {components.map((name) => {
          const Component = COMPONENT_MAP[name];
          if (!Component) return null;

          return <Component key={name} {...additionalProps} {...readingStats} />;
        })}
      </div>
    </main>
  );
};

export default MyTIContent;
